import { StoreImpl } from "../data/StoreImpl";
import { IStoreRepository } from "../domain/repositories/IStoreRepository";
import { StoreUseCase } from "../domain/useCases/StoreUseCase";
import { StoreManagementViewModel } from "../presentation/viewModel/StoreManagementViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class StoreInjection extends InjectionModule {
  private static readonly storeRepositoryToken = Symbol("IStoreRepository");
  private static readonly storeUseCaseToken = Symbol("StoreUseCase");
  private static readonly storeViewModelToken = Symbol("StoreViewModel");

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.storeRepositoryToken,
      useClass: StoreImpl,
    },
    {
      scope: "otherRepo",
      token: this.storeUseCaseToken,
      useClass: StoreUseCase,
    },
    {
      scope: "viewModel",
      token: this.storeViewModelToken,
      useClass: StoreManagementViewModel,
    },
  ];

  static getRepo(): IStoreRepository {
    return this.resolve(this.storeRepositoryToken);
  }

  static getUseCase(): StoreUseCase {
    return this.resolve(this.storeUseCaseToken);
  }
}
